import { pathOr } from 'ramda'

export const isDesktop = (browser) => {
  const infinity = pathOr(true, ['is', 'infinity'], browser)
  const large = pathOr(true, ['is', 'large'], browser)
  return infinity || large
}

export const isMedium = (browser) => {
  const {extraLarge, large, infinity} = (browser?.is || {})
  return extraLarge || large || infinity;
}

export const isMobiles = (browser) => {
  const medium = pathOr(true, ['is', 'medium'], browser)
  const small = pathOr(true, ['is', 'small'], browser)
  const extraSmall = pathOr(true, ['is', 'extraSmall'], browser)
  return small || extraSmall || medium
}


let isTouchDevice;

if (navigator.userAgentData && navigator.userAgentData.platform !== '') {
  isTouchDevice = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgentData.platform)
} else {
  isTouchDevice = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export {isTouchDevice};


